module.exports = __webpack_public_path__ + "img/loic.1c02a2e7.jpg";